import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Star, Quote, Heart } from 'lucide-react';
const testimonials = [{
  name: 'María G.',
  location: 'Ciudad de México',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=120&h=120&fit=crop&crop=face',
  quote: '¡Por fin mis mañanas tienen paz! Mi hijo ahora abre su lonchera emocionado y yo cierro la mochila sin culpa.',
  stars: 5,
  highlight: 'Mis mañanas tienen paz'
}, {
  name: 'Ana L.',
  location: 'Guadalajara',
  avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=120&h=120&fit=crop&crop=face',
  quote: 'Antes gastaba $800 pesos semanales en comida que terminaba en la basura. Ahora gasto la mitad y mis hijos comen mejor.',
  stars: 5,
  highlight: 'Gasto la mitad'
}, {
  name: 'Sofía R.',
  location: 'Monterrey',
  avatar: 'https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=120&h=120&fit=crop&crop=face',
  quote: 'La regla 1-1-1 me cambió la vida. Ya no pienso, solo armo la lonchera en 8 minutos y listo. ¡Gracias!',
  stars: 5,
  highlight: 'Me cambió la vida'
}, {
  name: 'Laura M.',
  location: 'Puebla',
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=120&h=120&fit=crop&crop=face',
  quote: 'Mi hija me dijo: "Mami, todas mis amigas quieren tu lonchera". Ese momento no tiene precio. 💛',
  stars: 5,
  highlight: 'No tiene precio'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 20,
    scale: 0.97
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      type: 'spring',
      stiffness: 180,
      damping: 18
    }
  }
};
export function TestimonialsSection() {
  return <section className="py-10 px-4 bg-cream-50" data-id="element-241">
      <div className="max-w-4xl mx-auto" data-id="element-242">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-243">
          <div className="flex items-center justify-center gap-1 mb-3" data-id="element-244">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-mostaza-500 fill-mostaza-500" data-id="element-245" />)}
          </div>
          <h2 className="text-2xl md:text-3xl font-black text-charcoal-900 mb-2" data-id="element-246">
            Lo que dicen las <span className="text-naranja-500" data-id="element-247">mamás</span> que
            ya lo usan
          </h2>
          <p className="text-base text-charcoal-600 font-medium" data-id="element-248">
            +2,500 mamás transformaron sus mañanas con este Kit
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-40px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-249">
          {testimonials.map((t, idx) => <motion.div key={idx} variants={cardVariants} className="bg-white rounded-2xl p-5 shadow-[0_4px_20px_-4px_rgba(0,0,0,0.08)] border border-cream-200 relative" data-id="element-250">
              {/* Quote icon */}
              <Quote className="absolute top-4 right-4 w-6 h-6 text-sage-200" data-id="element-251" />

              <div className="flex items-center gap-3 mb-3" data-id="element-252">
                <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-sage-300 shadow-sm flex-shrink-0" data-id="element-253">
                  <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" data-id="element-254" />
                </div>
                <div data-id="element-255">
                  <p className="font-bold text-charcoal-900 text-sm" data-id="element-256">
                    {t.name}
                  </p>
                  <p className="text-charcoal-500 text-xs" data-id="element-257">{t.location}</p>
                  <div className="flex items-center gap-0.5 mt-0.5" data-id="element-258">
                    {[...Array(t.stars)].map((_, i) => <Star key={i} className="w-3 h-3 text-mostaza-500 fill-mostaza-500" data-id="element-259" />)}
                  </div>
                </div>
              </div>

              <p className="text-charcoal-700 text-sm leading-relaxed" data-id="element-260">
                "{t.quote}"
              </p>

              <div className="mt-3 inline-flex items-center gap-1.5 bg-sage-50 text-sage-700 text-xs font-bold px-3 py-1 rounded-full border border-sage-200" data-id="element-261">
                <Heart className="w-3 h-3 text-naranja-500 fill-naranja-500" data-id="element-262" />
                {t.highlight}
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}